<template>
    <v-snackbar
        v-model="shows"
        v-bind="{
            absolute: true,
            bottom: true,

            text: true,
            elevation: 0,
            class: 'room-alert',
        }"
        timeout="2000"
        :style="{
            marginTop: `${-((alerts.length - (index + 1)) * (48 + 8))}px`,
        }"
    >
        <span> {{ alert }} </span>
    </v-snackbar>
</template>

<script>
import { mapState } from "vuex";
export default {
    props: {
        alert: { type: String, default: null },
        index: { type: Number, default: 0 },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        ...mapState("interview/server", ["alerts"]),
    },
    methods: {
        init() {
            this.shows = !!this.alert;
        },
    },
    watch: {
        alert() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.room-alert ::v-deep {
    .v-snack__wrapper {
        margin-bottom: 12px;
        min-width: auto;
    }
    .v-snack__content {
        padding: 12px 28px;
        font-size: 14px;
        text-align: center;
    }
    .v-snack__action {
        display: none !important;
    }
}
</style>